<template>
  <div class="appointment-batch-order-mode">
    <div class="card-container" style="padding: 20px; padding-left: 30px">
      <p class="section-title">{{ displayText.title }}</p>
      <AppointmentCoreFlowBlock
        :cartItem.sync="cart[0].cartItem"
        hideDateTimeSelector
        hideClassTicketSelector
      />
    </div>
    <AppointmentMultiplePeriodBlock v-if="showControl.block.periodBlock" />
  </div>
</template>

<script>
import { useCreateAppointment } from '@/use/useCreateAppointment'
import { computed, defineComponent, ref, watch } from 'vue'
import AppointmentMultiplePeriodBlock from './AppointmentMultiplePeriodBlock.vue'
import AppointmentCoreFlowBlock from './AppointmentCoreFlowBlock.vue'
import { get } from 'lodash'
import { i18n } from '@/plugins/i18n/i18n'

export default defineComponent({
  name: 'AppointmentBatchOrderMode',
  components: {
    AppointmentMultiplePeriodBlock,
    AppointmentCoreFlowBlock,
  },
  setup (props, { emit }) {
    const { cart, context } = useCreateAppointment()
    const mainPeriodCartItem = computed(() => get(cart.value, '[0].cartItem'))
    const showBlock = ref(false)
    const displayText = computed(() => {
      const data = {
        title: i18n.t('reservationOrderDetail.title'),
      }
      return data
    })
    const showControl = computed(() => {
      const controls = {
        block: {
          periodBlock: false,
        },
      }

      if (get(mainPeriodCartItem.value, 'service')) {
        controls.block.periodBlock = true
      }

      return controls
    })

    // ?? 重新顯示，取得新的nanoId
    watch([() => context.userType, () => context.peopleCount], () => {
      showBlock.value = false
      setTimeout(() => {
        showBlock.value = true
      }, 0)
    }, { immediate: true })

    return { cart, showControl, displayText, showBlock }
  },
})
</script>

<style lang="postcss" scoped>
.appointment-batch-order-mode {
  @apply flex flex-col gap-[24px];
}

.section-title {
  @apply font-bold text-primary-100 text-[18px] mb-[24px];
}
</style>
